import React, { useState, useEffect } from 'react';
import { Table, Container, Row, Col } from 'react-bootstrap';
import Loginheader from '../Loginheader';
import Menu from '../Menu';


import * as Common from '../Common';

function Full_Rate_Card() {
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [rateData, setRateData] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            refreshRate();
            sessionStorage.myInterval = setInterval(() => refreshRate(), 2000);
            setOnceRun(true);
        }
    }, [onceRun, refreshRate]);

    function refreshRate() {
        Common.callApi(Common.apiRate, [sid, 'listjson'], function (result) {
            setRateData(JSON.parse(result));
        });
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Rate Card</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className="divContentCenter">
                        <div className="maxFormWidth">
                            <Table responsive striped bordered hover>
                                <thead>
                                    <th className="textCenter" >Currency Code</th>
                                    <th className="textCenter">IBR</th>
                                </thead>
                                <tbody>
                                    {rateData.map((res) =>
                                        <tr>
                                            <td className="textCenter">{res.or_isd}</td>
                                            <td className="textRight">{res.or_sellrate}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default Full_Rate_Card;